package empiresmp.feature.votes.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.shapes.Circle
import com.varabyte.kobweb.silk.theme.shapes.clip
import org.jetbrains.compose.web.css.px
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette

@Composable
fun IconBackgroundComposable(
    background: Color,
    icon: String,
    modifier: Modifier = Modifier
) {
    val theme = LocalSitePalette.current

    Box(
        modifier = modifier.size(32.px)
    ) {
        Box(
            modifier = Modifier
                .size(32.px)
                .clip(Circle())
                .padding(theme.dimens.XS)
                .backgroundColor(background),
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = icon,
                modifier = Modifier.Companion
                    .fillMaxSize()
            )
        }
    }
}
